import { useState } from 'react'
import { Stepper } from '../Stepper'
import { SuccessView } from '../SuccessView'
import { Container } from './styles'

interface StepperWithSuccessPageProps {
  initialStep?: string
  onCancel?: () => void
  onFinish?: () => void
  steps: any[]
  title?: string
  subtitle?: string
  successButtonText?: string
  skipSuccessPage?: boolean
  stepperBreadcrumbTitles?: Record<string, any>
  stepWrapper: React.ElementType
  withButtons?: boolean
  [key: string]: any
}

export const StepperWithSuccessPage = ({
  initialStep,
  onCancel,
  onFinish,
  steps,
  title,
  subtitle,
  successButtonText,
  skipSuccessPage,
  stepperBreadcrumbTitles,
  ...rest
}: StepperWithSuccessPageProps) => {
  const [finished, setFinished] = useState(false)

  if (finished) {
    return (
      <Container>
        <SuccessView
          buttonText={successButtonText}
          onButtonClick={() => onFinish?.()}
          subtitle={subtitle}
          title={title}
        />
      </Container>
    )
  }

  return (
    <Stepper
      initialStep={initialStep}
      onCancel={onCancel}
      onFinish={skipSuccessPage ? onFinish : () => setFinished(true)}
      stepperBreadcrumbTitles={stepperBreadcrumbTitles}
      steps={steps}
      {...rest}
    />
  )
}
